import { defineStore } from 'pinia';
import { ApiErrorResponse } from '@/models/api/api-error.model';
import { ElNotification } from 'element-plus';
import { api } from '@/services/http.service';
import { TimestampModel } from '@/models/timestamp/timestamp.model';

type TimestampStore = {
  timestamp: string;
  isTimestampLoading: boolean;
  isTimestampRequired: boolean;
}

export const useTimestampStore = defineStore({
  id: 'TimestampStore',
  state: (): TimestampStore => ({
    timestamp: '',
    isTimestampLoading: false,
    isTimestampRequired: false,
  }),
  actions: {
    setTimestamp(timestamp: string): void {
      this.timestamp = timestamp;
    },
    setTimestampLoading(isLoading: boolean): void {
      this.isTimestampLoading = isLoading;
    },
    setTimestampRequired(isTimestampRequired: boolean): void {
      this.isTimestampRequired = isTimestampRequired;
    },
    getReportTimestamp(): Promise<TimestampModel | void> {
      this.setTimestampLoading(true);

      return api.timestamp.getTimestampRequest.perform().then(({ data }) => {
        this.setTimestamp(data.timestamp);

        return data;
      }).catch(error => {
        const apiError = error as ApiErrorResponse;
        ElNotification({
          title: 'Error',
          message: apiError.response.data.message,
          type: 'error',
        });
      })
        .finally(() => {
          this.setTimestampLoading(false);
        });
    },
  },
});
